module.exports = __webpack_public_path__ + "static/ios_paso_2-03ce59e854fcb48b919175f57b9d7144.png";